import { InputAdornment, Typography } from '@mui/material'
import { ReactNode } from 'react'

interface Props {
  unit: ReactNode
}
function UnitAdornment ({ unit }: Props) {
  return (
    <InputAdornment position="end" className="!h-fit pt-2">
      <Typography fontSize="0.8rem">
        {unit}
      </Typography>
    </InputAdornment>
  )
}

export default UnitAdornment
